import { ComponentProps, FC, useCallback } from "react"
import { countryUpdateApi } from "src/domain/api/country/countryUpdateApi"
import { Country } from "../../../../domain/entities/country"
import { useAuth } from "../../../../domain/hooks"
import { FormikOnSubmit } from "../../../../utils/types"
import { CountryUpdateDrawerFormView } from "./CountryUpdateDrawerFormView"
import { ICountryUpdateFormFields } from "./ICountryUpdateFormFields"

type Props = Omit<ComponentProps<typeof CountryUpdateDrawerFormView>, "handleSubmit"> & {
	onSuccess?: (country: Country) => void
}

export const CountryUpdateDrawerFormController: FC<Props> = ({
	country,
	onSuccess,
	...rest
}) => {
	const { token } = useAuth()

	const handleSubmit = useCallback<FormikOnSubmit<ICountryUpdateFormFields>>(
		async (values, { setErrors }) => {
			try {
				const updatedCountry = await countryUpdateApi(
					{ id: country.id, update: values },
					token,
				)
				onSuccess && onSuccess(updatedCountry)
				rest.onClose()
			} catch (err) {
				const message =
					err instanceof Error ? err.message : "Something went wrong"
				setErrors({ name: message })
			}
		},
		[onSuccess, rest, token, country.id],
	)

	return (
		<CountryUpdateDrawerFormView
			country={country}
			handleSubmit={handleSubmit}
			{...rest}
		/>
	)
}
